module.exports = "images/8ans.795229e8.png";